export default {
    // Stores vacation dates of the user's campus
    vacationDates: null,
    error: '',
};
